import {
  Footer_styles_default
} from "./chunk.R6D3NQR2.js";
import {
  l
} from "./chunk.LS2P7VOO.js";
import {
  o
} from "./chunk.DWZR6NQN.js";
import {
  e,
  n
} from "./chunk.W5GYKEPL.js";
import {
  $,
  s
} from "./chunk.X63DNLWS.js";
import {
  __decorateClass
} from "./chunk.LKRKSA4X.js";

// packages/web-components/src/components/Footer/Footer.ts
var Footer = class extends s {
  constructor() {
    super(...arguments);
    this.variant = "patient";
    this.navLabel = "Footer";
    this.newTab = false;
  }
  getCopyrightText() {
    const patientCopyrightText = "Myriad Genetics, AMPLIFY, Foresight, MyRisk, Prequel, RiskScore and their respective logos are registered trademarks or trademarks of Myriad Genetics, Inc. and its subsidiaries.";
    const providerCopyrightText = "Myriad Genetics, MyRisk, Foresight, Prequel, AMPLIFY, RiskScore, Precise, MyChoice, BRACAnalysisCDx and their respective logos are registered trademarks of Myriad Genetics, Inc. and its subsidiaries.";
    if (this.copyright) {
      return this.copyright;
    } else if (this.variant === "patient") {
      return patientCopyrightText;
    } else if (this.variant === "provider") {
      return providerCopyrightText;
    }
    return patientCopyrightText;
  }
  render() {
    const year = new Date().getFullYear();
    const isPatient = this.variant === "patient";
    const isProvider = this.variant === "provider";
    const copyrightText = this.getCopyrightText();
    const target = this.newTab ? "_blank" : void 0;
    const rel = this.newTab ? "noopener noreferrer" : void 0;
    return $`
      <footer
        part="base"
        class=${o({
      footer: true,
      "footer--provider": isProvider
    })}
      >
        <div
          class=${o({
      footer__wrapper: true,
      "footer__wrapper--provider": isProvider
    })}
        >
          <div
            class=${o({
      footer__policies: true,
      "footer__policies--provider": isProvider
    })}
            data-testid="policies-desktop"
          >
            <div>
              <span>©${year} Myriad Genetics, Inc.</span>
              <a
                part="myriad__link"
                href="https://www.myriad.com"
                target=${l(target)}
                rel=${l(rel)}
                class="footer__policies__link"
              >
                www.Myriad.com
              </a>
            </div>
            <div
              class=${o({
      footer__trademark: true,
      "footer__trademark--patient": isPatient,
      "footer__trademark--provider": isProvider
    })}
              data-testid=${isPatient ? "trademark-patient" : "trademark-provider"}
            >
              ${copyrightText}
            </div>
          </div>
          <nav
            class=${o({
      footer__nav: true
    })}
            aria-label="${l(this.navLabel)}"
          >
            ${this.links !== void 0 && this.links.length > 0 ? this.links.map((link) => $`
                    <a
                      href=${link.url}
                      target=${l(target)}
                      rel=${l(rel)}
                      class=${o({
      footer__nav__item: true,
      "footer__nav__item--provider": isProvider
    })}
                    >
                      ${link.text}
                    </a>
                  `) : $`
                  <a
                    href="https://myriad.com/terms-of-use/"
                    target=${l(target)}
                    rel=${l(rel)}
                    class=${o({
      footer__nav__item: true,
      "footer__nav__item--provider": isProvider
    })}
                  >
                    Terms of Use
                  </a>
                  <a
                    href="https://myriad.com/privacy-notice/"
                    target=${l(target)}
                    rel=${l(rel)}
                    class=${o({
      footer__nav__item: true,
      "footer__nav__item--provider": isProvider
    })}
                  >
                    Privacy Notice
                  </a>
                  <a
                    href="https://myriad.com/notice-privacy-practices/"
                    target=${l(target)}
                    rel=${l(rel)}
                    class=${o({
      footer__nav__item: true,
      "footer__nav__item--provider": isProvider
    })}
                  >
                    HIPAA Notice of Privacy Practices
                  </a>
                  <a
                    href="https://myriad.com/contact-us/"
                    target=${l(target)}
                    rel=${l(rel)}
                    class=${o({
      footer__nav__item: true,
      "footer__nav__item--provider": isProvider
    })}
                  >
                    Contact
                  </a>
                `}
          </nav>
          <div
            class=${o({
      footer__policies: true,
      "footer__policies--provider": isProvider
    })}
            data-testid="policies-mobile"
          >
            <div>
              <span>©${year} Myriad Genetics, Inc.</span>
              <a
                part="myriad__link"
                href="https://www.myriad.com"
                target=${l(target)}
                rel=${l(rel)}
                class="footer__policies__link"
              >
                www.Myriad.com
              </a>
            </div>
            <div
              class=${o({
      footer__trademark: true,
      "footer__trademark--patient": isPatient,
      "footer__trademark--provider": isProvider
    })}
              data-testid=${isPatient ? "trademark-patient" : "trademark-provider"}
            >
              ${copyrightText}
            </div>
          </div>
        </div>
      </footer>
    `;
  }
};
Footer.styles = Footer_styles_default;
__decorateClass([
  e()
], Footer.prototype, "variant", 2);
__decorateClass([
  e()
], Footer.prototype, "navLabel", 2);
__decorateClass([
  e()
], Footer.prototype, "copyright", 2);
__decorateClass([
  e({ type: Boolean, reflect: true })
], Footer.prototype, "newTab", 2);
__decorateClass([
  e({ type: Array, reflect: true })
], Footer.prototype, "links", 2);
Footer = __decorateClass([
  n("myd-footer")
], Footer);

export {
  Footer
};
